<template>
  <div class="address-exchange-display-modal">
    <modal-frame :showModalFlag="modalDisplay" v-on:backdropClickEvent="closeModal">
      <div class="modal-header">
        <h1>連絡先交換QR</h1>
        <img src="/images/close_icon.svg" @click="closeModal" />
      </div>
      <div class="modal-body">
        <div class="qr-display-column" v-if="addressExchangeToken">
          <vue-qrcode
            :value="addressExchangeToken.token"
            :options="{
              errorCorrectionLevel: 'Q',
              width: 300,
            }"
          ></vue-qrcode>
        </div>
      </div>
    </modal-frame>
  </div>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { mapActions } from 'vuex'

import ModalFrame from '@/components/common/ModalFrame.vue'

export default {
  name: 'AddressExchagneDisplayModal',

  components: {
    VueQrcode,
    ModalFrame,
  },

  props: {
    addressCategory: Object,
    modalDisplay: Boolean,
  },

  emits: [
    'addressExchangeFinishedEvent',
    'closeModalEvent',
  ],

  data () {
    return {
      poolingIntervalID: null,
      addressExchangeToken: null,
    }
  },

  watch: {
    modalDisplay: { handler: 'initData', immediate: true }
  },

  beforeUnmount () {
    this.stopPoolingAction()
  },

  methods: {
    ...mapActions({
      createExchangeToken: 'addressExchangeToken/create',
      fetchExchangeToken: 'addressExchangeToken/fetch',
      fetchAddressBook: 'addressBook/fetch',
    }),

    initData () {
      if (this.modalDisplay) {
        this.addressExchangeToken = null
        this.createToken()
      } else {
        this.addressExchangeToken = null
        this.stopPoolingAction()
      }
    },

    startPoolingAction () {
      if (this.poolingIntervalID) {
        clearInterval(this.poolingIntervalID)
      }
      this.poolingIntervalID = setInterval(() => {
        this.fetchTokenState()
      }, 5000)
    },

    stopPoolingAction () {
      if (this.poolingIntervalID) {
        clearInterval(this.poolingIntervalID)
      }
    },

    createToken () {
      console.log(this.addressCategory.id)
      this.createExchangeToken(this.addressCategory.id).then(res => {
        console.log('on component')
        console.log(res)
        this.addressExchangeToken = res
        this.startPoolingAction()
      })
    },

    fetchTokenState () {
      this.fetchExchangeToken(this.addressExchangeToken.id).then(res => {
        console.log('on component' + res)
        console.log(res)
        // console.log(res.data.address_exchange_token)
        if (res.used_at) {
          // stop pooling
          this.stopPoolingAction()
          // create message
          let resultMessage = '連絡先交換を完了しました。\n'
          if (res.own_exist) {
            resultMessage += '交換先にはすでにあなたの連絡先は登録済みでした。\n'
          }
          if (res.own_success) {
            resultMessage += '交換先にあなたの連絡先を登録しました。\n'
          }
          if (res.target_exist) {
            resultMessage += 'あなたの連絡帳にはすでに交換先は登録済みでした。\n'
          }
          if (res.target_success) {
            resultMessage += 'あなたの連絡帳に交換先を登録しました。\n'
          }
          this.fetchAddressBook()
          this.$emit('addressExchangeFinishedEvent', resultMessage)
        }
      })
    },

    closeModal () {
      this.$emit('closeModalEvent')
    },

  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
@import '@/assets/css/mediaQuery.scss';
@import '@/assets/css/colorTable.scss';

.address-exchange-display-modal {
  margin: 0;
  .modal-header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    padding-bottom: 0;
    h1 {
      margin: 0;
      font-size: 22pt;
      font-weight: normal;
    }
    img {
      width: 26px;
    }
  }
  .modal-body {
    padding: 15px;
    padding-top: 0;
    .qr-display-column {
      text-align: center;
    }
  }
}
</style>